import { listFaqs } from '@/api/faqs.js';

const state = {
  downloadFaqs: [],
  creditsFaqs: [],
  subscriptionFaqs: [],
  loading: false,
};

const actions = {
  LIST_FAQS({ commit }, type) {
    commit('setLoading', true);
    return listFaqs(type)
      .then((response) => {
        commit('setFaqs', { type, faqs: response.data.data });
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setFaqs(state, { type, faqs }) {
    switch (type) {
      case 'download':
        state.downloadFaqs = faqs;
        break;
      case 'credits':
        state.creditsFaqs = faqs;
        break;
      case 'subscription':
        state.subscriptionFaqs = faqs;
        break;
      // no default
    }
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};


